import { Flex, LINK_VARIANT_EXTRALIGHT, Link } from 'mailup-web-components'
import React, { type FC } from 'react'
import { useRecoilCallback } from 'recoil'

import IconTrashCan from 'Components/icons/IconTrashCan'

import { removeCriterionCallback } from 'Pages/RecipientsList/recoil/callbacks/filters'

interface ActionDeleteCriterionProps {
  index: number
}

const ActionDeleteCriterion: FC<ActionDeleteCriterionProps> = ({ index }) => {
  const removeCriterion = useRecoilCallback(removeCriterionCallback, [])

  const handleClick = (): void => {
    void removeCriterion(index)
  }
  return (
    <Flex height="36px" alignItems="center" justifyContent="flex-start">
      <Link
        variant={LINK_VARIANT_EXTRALIGHT}
        data-mu-test="delete-criterion"
        onClick={handleClick}
        alignContent
      >
        <IconTrashCan />
      </Link>
    </Flex>
  )
}

export default ActionDeleteCriterion
